export enum SidekickTab {
  Assessment = 'Candidate Assessment',
  Questions = 'Interview Questions',
}
